// The chart mark id of a shipping lane (round 088 card 09, R2658): the
// pick of chart card 16 names the lane with it, and the press and the
// peek read it back. The module imports nothing, so the chart piece and
// the commands take it without the card modules.

/** The prefix of the chart mark id of a lane. */
const LANE_MARK = 'lane:';

/** One lane of the faction: its commander (0 for an own plot, whose
 *  `CoursePlot.owner` is 0) and its plot id. */
export interface LaneRef { owner: number; id: number }

/** The chart mark id of a lane: `lane:<owner>:<plot>`. */
export function laneMarkId(owner: number, id: number): string {
  return `${LANE_MARK}${owner}:${id}`;
}

/** The lane a chart mark id names, or null for another mark. */
export function laneOfMark(markId: string): LaneRef | null {
  if (!markId.startsWith(LANE_MARK)) return null;
  const [o, i] = markId.slice(LANE_MARK.length).split(':');
  const owner = Number(o), id = Number(i);
  return Number.isInteger(owner) && Number.isInteger(id) && id > 0 ? { owner, id } : null;
}
